/* istanbul ignore file */
export const TICK = "tick";
export const INFORMATION = "information";
